import Home from '../pages/Home';
import Use from '../pages/Use';
import Example from '../pages/Example';
import More from '../pages/More'
import Encyclopedia from '../pages/Encyclopedia'
import Partner from '../pages/Partner'
import Affiliate from "../pages/Affiliate";
// import HelpLook from '../pages/HelpLook';
import Ecommerce from '../pages/Ecommerce';
import PrivateCN from '../pages/Privacy/CN';
import PrivateEN from '../pages/Privacy/EN';
import AppSolution from '../pages/AppSolution';
import WhitePaper from '../pages/white-paper/index.jsx';
import Comparison from '../pages/Comparison';
import FeatureLanding from '../pages/FeatureLanding';
// import Anniversary from '../pages/Anniversary';


const routers = [
  {
    title: 'Home',
    path: '/',
    component: Home,
  },
  {
    title: 'Home',
    path: '/:lang',
    component: Home,
  },
  {
    title: 'Use',
    path: '/:lang/use',
    component: Use,
  },
  {
    title: 'Example',
    path: '/:lang/example',
    component: Example,
  },
  {
    title: 'More',
    path: '/:lang/more/:name',
    component: More,
  },
  {
    title:'Encyclopedia',
    path:'/cn/encyclopedia',
    component: Encyclopedia
  },
  {
    title:'Partner',
    path:'/:lang/partner',
    component: Partner
  },
  {
    title:'Affiliate',
    path:'/cn/affiliate',
    component: Affiliate
  },
  {
    title:'Ecommerce',
    path: '/cn/ecommerce',
    component: Ecommerce
  },
  {
    title:'PrivacyCN',
    path:'/cn/privacy',
    component: PrivateCN
  },
  {
    title:'PrivateEN',
    path:'/en/privacy',
    component: PrivateEN
  },
  {
    title:'AppSolution',
    path:'/:lang/appsolution',
    component: AppSolution
  },
  {
    title:'White Paper',
    path:'/:lang/report/2025-global-mobile-gaming-ua-trends-strategy',
    component: WhitePaper
  },
  {
    title: 'XMP vs Madgicx',
    path: '/en/comparison/xmp-vs-madgicx',
    component: Comparison,
  },
  {
    title: 'XMP vs Smartly',
    path: '/en/comparison/xmp-vs-smartly',
    component: Comparison,
  },
  {
    title: '广告管理',
    path: '/cn/ad-management',
    component: FeatureLanding,
  },
  {
    title: '批量搭建',
    path: '/cn/batch-builder',
    component: FeatureLanding,
  },
  {
    title: '素材中心',
    path: '/cn/creative-center',
    component: FeatureLanding,
  },
  // {
  //   title: 'Anniversary',
  //   path: '/:lang/5thanniversary',
  //   component: Anniversary,
  // },
  // {
  //   title:'HelpLook',
  //   path:'/:lang/blog',
  //   component: HelpLook
  // },
  {
    title: '404',
    path: '*',
    component: Home,
  },
];

export default routers;
